var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".\\33 c1a2674-5d0b-4a25-a87a-b010f332d95e{fill:#222;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Asset 1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "7a4fb1d9-5a11-48de-921c-5d1b6cd34d5c",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "52fcfe4d-cc25-4d01-a8dc-8d969b36f374",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "3c1a2674-5d0b-4a25-a87a-b010f332d95e",
    d: "M50,0a50,50,0,1,0,50,50A50,50,0,0,0,50,0Zm0,4.55A45.45,45.45,0,1,1,4.55,50,45.4,45.4,0,0,1,50,4.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "3c1a2674-5d0b-4a25-a87a-b010f332d95e",
    d: "M32.69,30.67a2.26,2.26,0,0,0-2,2.48,2.23,2.23,0,0,0,.69,1.43L46.75,50,31.34,65.44a2.28,2.28,0,1,0,3.23,3.23h0L50,53.22,65.43,68.67a2.28,2.28,0,1,0,3.23-3.23h0L53.21,50,68.66,34.58a2.28,2.28,0,0,0,.06-3.22A2.32,2.32,0,0,0,67,30.67a2.24,2.24,0,0,0-1.56.68L50,46.76,34.57,31.35a2.28,2.28,0,0,0-1.63-.68Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.970cbf4570265170090fe11a4750dddb.svg";
export { ForwardRef as ReactComponent };